import { render, staticRenderFns } from "./wolt_export.vue?vue&type=template&id=ff890f74&scoped=true&"
import script from "./wolt_export.vue?vue&type=script&lang=js&"
export * from "./wolt_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff890f74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff890f74')) {
      api.createRecord('ff890f74', component.options)
    } else {
      api.reload('ff890f74', component.options)
    }
    module.hot.accept("./wolt_export.vue?vue&type=template&id=ff890f74&scoped=true&", function () {
      api.rerender('ff890f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/wolt/wolt_export.vue"
export default component.exports